package games.polyclub.website.frontend.store.pages.aof7

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.website.frontend.store.components.ImageDetails
import games.polyclub.website.frontend.store.components.ImageSelection
import react.Props

val AOF7Images = SFC<Props> { _ ->
    ImageSelection {
        images = listOf(
            ImageDetails("/img/aof7/screenshot/tela-inicial.jpg", "Tela Inicial", "Tela Inicial do Modpack"),
            ImageDetails("/img/aof7/screenshot/dimensao-abelhas.png", "Dimensão de Abelhas", "Dimensão de Abelhas"),
            ImageDetails("/img/aof7/screenshot/polyana-lobometalurgico-recrutinha.png", "Jogadories Jogando", "Alguns jogadories jogando"),
            ImageDetails("/img/aof7/screenshot/casa-de-player-1.png", "Uma casa de jogadorie", "Casa construída por um jogadorie"),
            ImageDetails("/img/aof7/screenshot/casa-de-player-2.png", "Uma casa de jogadorie", "Casa construída por um jogadorie"),
            ImageDetails("/img/aof7/screenshot/maquinas-de-player-1.png", "Um sistema montado por jogadorie", "Sistema construído por um jogadorie"),
            ImageDetails("/img/aof7/screenshot/maquinas-de-player-2.png", "Um sistema montado por jogadorie", "Sistema construído por um jogadorie"),
            ImageDetails("/img/aof7/screenshot/maquinas-de-player-3.png", "Um sistema montado por jogadorie", "Sistema construído por um jogadorie"),
        )
    }
}
